import { render, staticRenderFns } from "./add-wallet-movement-modal.vue?vue&type=template&id=3ff6dc81&scoped=true&"
import script from "./add-wallet-movement-modal.vue?vue&type=script&lang=ts&"
export * from "./add-wallet-movement-modal.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ff6dc81",
  null
  
)

export default component.exports